import toMillis from '../measurementSignals/toMillis'

/**
 * @typedef {object} LatestActivity
 * @property {number|null} atMs - Tijdstempel van het nieuwste item in milliseconden
 * @property {string|null} label - Datum van dat item in nl-NL notatie, bijv. '14-4-2026'
 * @property {number|null} daysAgo - Hele dagen sinds dat moment; negatief als het in de toekomst ligt
 */

const DATE_OPTIONS = { day: 'numeric', month: 'numeric', year: 'numeric' }

const DAY_IN_MS = 1000 * 60 * 60 * 24

/** Niets gevonden, en niets beweerd: 'nog niet geladen' en 'leeg' geven allebei dit terug. */
const NOTHING = { atMs: null, label: null, daysAgo: null }

/**
 * Wanneer gebeurde het NIEUWSTE item in deze lijst, en hoe lang is dat geleden?
 *
 * Kiest op de grootste tijdstempel, niet op een positie in de lijst. Dat is de
 * hele reden dat deze helper bestaat: drie kolommen op Portfolio -> Voortgang
 * pakten `items[items.length - 1]` uit een lijst die de hook AFLOPEND ophaalt
 * (`orderBy('Timestamp', 'desc')`), en toonden zo maandenlang het OUDSTE item
 * als 'Laatste'. Op de live gegevens stond er 7-10-2025 waar 14-4-2026 hoorde.
 * Erger dan de datum was de kleur: `daysAgo` kwam uit datzelfde oude item, dus
 * een project kleurde voor altijd rood zodra het ooit iets ouds bevatte.
 *
 * Een helper die zelf op positie koos zou die fout alleen verplaatsen — vandaar
 * dat de sorteervolgorde van de aanroeper hier niet uitmaakt.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 *
 * @param {Array<object>|string|null|undefined} items - Documenten; de leesengine geeft `''` zolang de read loopt
 * @param {string} [field] - Veld waarin de datum staat
 * @returns {LatestActivity}
 */
const latestActivity = (items, field = 'Timestamp') => {
    if (!Array.isArray(items)) return NOTHING

    let atMs = null
    items.forEach((item) => {
        const ms = toMillis(item?.[field])
        if (ms === null) return
        if (atMs === null || ms > atMs) atMs = ms
    })

    if (atMs === null) return NOTHING

    return {
        atMs,
        label: new Date(atMs).toLocaleDateString('nl-NL', DATE_OPTIONS),
        daysAgo: Math.floor((Date.now() - atMs) / DAY_IN_MS),
    }
}

export default latestActivity
